import React from 'react';

module.exports = React.createClass({
  render(){
    var clsName = 'glyphicon glyphicon-'+this.props.name;
    return <span className={clsName}></span>;
  }
});


/** WEBPACK FOOTER **
 ** ./src/components/icon.js
 **/